export class PointsAccountingException extends Error {

}
